import { render, staticRenderFns } from "./LegalEntityClinic.vue?vue&type=template&id=1df5dd6e&scoped=true"
import script from "./LegalEntityClinic.vue?vue&type=script&lang=js"
export * from "./LegalEntityClinic.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityClinic.vue?vue&type=style&index=0&id=1df5dd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5dd6e",
  null
  
)

export default component.exports